import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from "@angular/material/icon";
import { PLUS_ICON, DELETE_ICON, DOWNLOAD_ICON } from '../utils/svgIcons';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { PermisosAutomatizadosService } from '../services/permisos-automatizados.service';
import Swal from 'sweetalert2';
import { decrypt } from '../utils/constants';

@Component({
  selector: 'app-perfilado',
  templateUrl: './perfilado.component.html',
  styleUrls: ['./perfilado.component.scss'],
  providers: [NgbModalConfig, NgbModal]
})

export class PerfiladoComponent implements OnInit {
  step: number = 0;
  onProfileSelected: number = null;
  usuarioData: any = []
  perfiles: any = [
    {position: 1, name: 'Gerente'},
    {position: 2, name: 'Directivos'},
    {position: 3, name: 'Empleados'},
  ];
  dataSource: any [];
  dataSourceBackup: any [];
  filteredData: any [];

  constructor(
    private modalService: NgbModal,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private ngxService: NgxUiLoaderService,
    private permisosAutomatizados: PermisosAutomatizadosService,
    sanitizer: DomSanitizer,
    iconRegistry: MatIconRegistry, ){
      iconRegistry.addSvgIconLiteral('icon-plus', sanitizer.bypassSecurityTrustHtml(PLUS_ICON));
      iconRegistry.addSvgIconLiteral('icon-delete', sanitizer.bypassSecurityTrustHtml(DELETE_ICON));
      iconRegistry.addSvgIconLiteral('icon-download', sanitizer.bypassSecurityTrustHtml(DOWNLOAD_ICON));
   }

  ngOnInit(): void {
    console.log('VERSION: 1.0.4');
    this.usuarioData = {
      idUsuario: this.activatedRoute.snapshot.params['idUsuario'],
      idCliente: this.activatedRoute.snapshot.params['idCliente'],
    }
    localStorage.setItem("usuario", JSON.stringify(this.usuarioData));
    this.initDataSource(this.usuarioData.idUsuario)
  }

  async initDataSource(idUser: any) {
    this.ngxService.start();
    try {
      const result: any = await this.permisosAutomatizados.getProfiles(idUser);
      const decoded: any = await decrypt({ data: result.data });
      let response: any = decoded.data
      let perfiles = []
      
      if( response.code === 200 ) { 
        //Agregar campo 'valueId'
        response.items[0].perfiles.forEach(element => {
          let x = element.nombrePerfil.split(" ");
          
          //Valida si el elemento es un numero
          if(/^[0-9]+[.]{0,1}[0-9]*$/.test(x[0])) { 
            let idValue = parseInt(x[0])
            x.shift() 
            
            perfiles.push({
              idPerfil: element.idPerfil,
              nombrePerfil: element.nombrePerfil,
              valueId: idValue,
              subName: x.join(" "),
            })
          } 
          else {
            perfiles.push({
              idPerfil: element.idPerfil,
              nombrePerfil: element.nombrePerfil,
              valueId: 9999,
              subName: element.nombrePerfil,
              lastUpdate: element['lastUpdate'] ? element.lastUpdate : null,
            })
          }
        });
        this.dataSource = perfiles.sort((a, b) => a.valueId - b.valueId);
        this.dataSourceBackup = perfiles
      }
      else {
        this.ngxService.stop();
        return this.showAlert('Algo salió mal', `Espere unos segundos y vuelva a intentar por favor.`)
      }
      this.ngxService.stop();

    } catch(err) {
      console.log(err);
      this.ngxService.stop();
      return this.showAlert('Error al obtener información', `Lo sentimos, hubo un problema en el servicio, favor de volver a intentar.`)
    }
  }

  showAlert( title: string, message: string ) {
    Swal.fire({
      title: title,
      icon:  'info',
      text:  message,
      confirmButtonColor: '#545D6E',
      confirmButtonText: '<span style="color: #ffffff"> Entendido </span>',
    })
  }

  onDeleteItem(item: any) {
    this.onProfileSelected = item.idPerfil
  }

  async deleteItem() {
    this.ngxService.start();
    try {
      const result: any = await this.permisosAutomatizados.deleteProfile(this.onProfileSelected, this.usuarioData.idUsuario);
      const decoded: any = await decrypt({ data: result.data });
      let response: any = decoded.data
      
      if( response.code === 200 ) {
        this.onProfileSelected = null
        this.initDataSource(this.usuarioData.idUsuario)
      }
      else {
        this.ngxService.stop();
        return this.showAlert('Algo salió mal', `Espere unos segundos y vuelva a intentar por favor.`)
      }
      
    } catch(err) {
      console.log(err);
      this.ngxService.stop();
      return this.showAlert('Error al eliminar perfil', `Lo sentimos, hubo un problema en el servicio, favor de volver a intentar.`)
    }
  }

  openModal(modalId: any){
    this.modalService.open(modalId);
  }

  changeView(route: string, props: any) {
    if ( route === 'propiedades-perfil'){
      this.router.navigate(['propiedades-perfil'], { state: { item: props } });
    }
    else { return }
  }

  async onChangeFilter(filterType: Number) {
    let items = null
    this.ngxService.start();

    switch (filterType) {
      case 0: // sort by valueId
        items = this.dataSourceBackup.sort((a, b) => a.valueId - b.valueId);
        break;

      case 1: // sort by name
        items = this.dataSourceBackup.sort((a, b) => {
          const nameA = a.subName.toUpperCase(); // ignore upper and lowercase
          const nameB = b.subName.toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
        
          // names must be equal
          return 0;
        });
        break;
      default:
        console.log("Indice no encontrado.");
    }

    setTimeout(() => {
      this.dataSource = items
      this.ngxService.stop();
    }, 300);
  }

  filterByName(textKey: any) {
    const filterValue = (textKey.target as HTMLInputElement).value;
    
    if (filterValue == '') {
      this.dataSource = this.dataSourceBackup;
    } 
    else {
      this.filteredData = this.dataSourceBackup.filter(datum => ( 
        datum.nombrePerfil.toLowerCase().indexOf(filterValue.toLowerCase()) > -1)
      );

      this.dataSource = this.filteredData;
    }
  }

}
